export default __webpack_public_path__ + "images/69ecaacd782b146a56f0c5795f286a1b.svg";